"use client";

import { useIsomorphicLayoutEffect } from 'hooks/useIsomorphicLayoutEffect';
import { noop } from 'utils/noop';

export type UseBodyScrollLockOptions = {
  enabled?: boolean;
};

/**
 * Lock body scrolling on mount.
 */

export function useBodyScrollLock({
  enabled = true,
}: UseBodyScrollLockOptions = {}) {
  useIsomorphicLayoutEffect(() => {
    if (enabled) {
      const originalStyle = window.getComputedStyle(document.body).overflow;
      document.body.style.overflow = 'hidden';
      return () => {
        document.body.style.overflow = originalStyle;
      };
    }

    return noop;
  }, [enabled]);
}
